<template>
	<div class="inspection">
		<div class="nav">
			<div class="nav-left">
				<div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toOxygenSensor">
					<div>氧气传感器</div>
				</div>
				<div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toCarbonDioxideSensor">
					<div>二氧化碳传感器</div>
				</div>
				<div class="parallelogram-btn-left" @click="toTemperatureAndHumiditySensor">
					<div>温湿度传感器</div>
				</div>
			</div>
			<div class="nav-center">历史数据</div>
			<div class="nav-right">
				<div class="parallelogram-btn-right" style="margin-right: 0.5vw" @click="toTemperatureSensor">
					<div>包芯温度传感器</div>
				</div>
				<div class="parallelogram-btn-right parallelogram-btn-active" style="margin-right: 0.5vw">
					<div>包芯水分传感器</div>
				</div>
				<div class="parallelogram-btn-right" @click="toTypeStatistics">
					<div>在垛传感器数量</div>
				</div>
			</div>
		</div>
		<div class="historyData-select">
			<div class="report-select-top">
				<div style="margin-right: 0.6vw">
					<DropDown :content="warehouseTitle" :items="warehouse" @sendInfo="showInfoW"></DropDown>
				</div>
				<div style="margin-right: 0.6vw">
					<DropDown message="请选择仓库" :content="buildingTitle" :items="building" @sendInfo="showInfoB">
					</DropDown>
				</div>
				<div style="margin-right: 0.6vw">
					<DropDown message="请选择楼号" :content="floorTitle" :items="floor" @sendInfo="showInfoF"></DropDown>
				</div>
				<div style="margin-right: 0.6vw">
					<DropDown message="请选择层号" :content="areaTitle" :items="area" @sendInfo="showInfoA"></DropDown>
				</div>
				<div style="margin-right: 0.6vw">
					<DropDown message="请选择垛位" :content="stackTitle" :items="stack" @sendInfo="showInfoS"></DropDown>
				</div>
				<div style="margin-right: 0.6vw">
					<DropDown :content="maintainStageName" :items="maintainStageData" v-on:sendInfo="showInfoMaintainStag">
					</DropDown>
				</div>
			</div>
			<div class="report-select-bottom">
				<div class="report-select-left">
					<div class="six-font-wrapper">
						<div class="icon-font">&#xe601;</div>
						导出数据报表
						<button readonly="readonly" style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
              " @click="DataDaoExcelClick" />
					</div>
					<div style="margin-left: 0.7vw">
						<DropDown content="请选择按月/周/天统计" :items="CountType" v-on:sendInfo="showInfoCountType"
							style="z-index: 9; position: relative"></DropDown>
					</div>
					<!-- 起点 -->
					<div class="input-wrapper" style="width: 10vw">
						<input v-model="startTimeData" @change="endTimeChange" placeholder="起点（24小时制）" />
						<div class="input-suffix">（点）</div>
					</div>
					<!-- 终点 -->
					<div class="input-wrapper" style="width: 10vw">
						<input v-model="endTimeData" placeholder="终点（24小时制）" />
						<div class="input-suffix">（点）</div>
					</div>
				</div>
				<div class="report-select-right">
					<div class="input-date-wrapper-switch">
						<span>是否选择仓间:</span>
						<el-switch v-model="storehouseFlag" inactive-color="#747d8c">
						</el-switch>
					</div>
					<div class="input-date-wrapper" style="margin-right: 0vw">
						<el-date-picker v-model="time" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
							start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</div>
				</div>
			</div>
			<div class="report-select-bottom" style="">
				<!-- 左边 -->
				<div class="report-select-left">
					<!-- 氧气浓度下限 -->
					<div class="input-wrapper" style="margin-left: 0vw">
						<input v-model="lowerVal" placeholder="水分下限" />

					</div>
					<!-- 氧气浓度上限 -->
					<div class="input-wrapper" style="margin-left: 0.6vw">
						<input v-model="upperVal" placeholder="水分上限" />

					</div>
					<!-- 包括 -->
					<div style="margin-left: 0.7vw">
						<DropDown content="不包括" :items="BaoKuoSelect" v-on:sendInfo="BaoKuoSelectType"
							style="z-index: 9; position: relative"></DropDown>
					</div>
					<!-- 数据对比 -->
					<div class="four-font-wrapper" style="margin-left: 0.4vw">
						数据对比
						<button slot="reference" readonly="readonly" style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
              " @click="contrastShow" />
					</div>
					<!-- 数据对比时间点 -->
					<div class="input-wrapper" style="margin-left: 0.6vw;width:8vw">
						<input v-model="DataDBi" placeholder="（24小时制）" />
						<div class="input-suffix">（点）</div>
					</div>
					<div style="margin-left: 1.7vw">
						<YuJingTian content="预警" :items="YuJingT" v-on:sendInfo="YuJingTiType"
							style="z-index: 9; position: relative"></YuJingTian>
					</div>
					<div class="input-wrapper" style="margin-left: 0.6vw; width: 4vw">
						<input v-model="val" placeholder="预警值" />
					</div>
				</div>
				<!-- 右边 -->
				<div class="report-select-right">
					<div class="query button" @click="handleSearch()">查询</div>
				</div>
			</div>
		</div>
		<div class="task-content">
			<div class="detail">
				<div class="detail-box">
					<div class="loading-data" v-if="loading" style="margin-top: 15vh">
						<i class="el-icon-loading"></i>
						<div>加载中，请稍后···</div>
					</div>
					<div class="detail-nav">
						<div class="detail-item" style="width: 3%">
							<div class="select-icon" :class="{ 'select-icon-active': all }" @click="selectAll"></div>
						</div>
						<div class="detail-item" style="width: 12.1%">序号</div>
						<div class="detail-item" style="width: 12.1%">设备ID</div>
						<div class="detail-item" v-show="!compare" v-if="!SelectConut" style="width: 12.1%">
							水分
						</div>
						<div class="detail-item" v-show="!compare" v-else style="width: 12.1%">平均水分</div>
						<div class="detail-item" v-show="compare" style="width: 12.1%">
							天数
						</div>
						<div class="detail-item" style="width: 12.1%">垛位号</div>
						<div class="detail-item" style="width: 20.1%">坐标</div>
						<div class="detail-item" style="width: 12.1%">烟叶代码</div>
						<div class="detail-item" v-if="!compare" v-show="!SelectConut" style="width: 20.1%">创建时间</div>
						<!-- <div class="detail-item" style="width: 20.1%">封垛时间</div> -->
						<div class="detail-item" style="width: 25.1%">选择</div>
					</div>
					<div class="detail-content" v-if="!loading">
						<div class="detail-list-wrapper" style="justify-content: end"
							v-if="!loading && tableData.length > 0" v-for="(data, index) in tableData" :key="index">
							<div class="detail-item" style="width: 3%">
								<div class="select-icon" :class="{ 'select-icon-active': data.sign === 1 }"
									@click="selectSingle(data)"></div>
							</div>
							<div class="detail-item" style="width: 12.1%">
								{{ index + 1 }}
							</div>
							<div class="detail-item" style="width: 12.1%">
								{{ data.nodeId || "--" }}
							</div>
							<div v-show="!compare" class="detail-item" style="width: 12.1%">
								{{ SelectConut != "" ? data.avgVal : data.val }}
							</div>
							<div v-show="compare" class="detail-item" style="width: 12.1%">
								{{ data.numberDays }}
							</div>
							<!-- <div class="detail-item" style="width: 13.9%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.materialName"
                >
                  <div
                    class="popover"
                    style="width: 8vw; text-align: center"
                    slot="reference"
                  >
                    {{ data.materialName ? data.materialName : "--" }}
                  </div>
                </el-popover>
              </div> -->
							<div class="detail-item" style="width: 12.1%">
								{{ data.stack || "--" }}
							</div>
							<div class="detail-item" style="width: 20.1%">
								X:{{ data.x || "--" }} Y:{{ data.y || "--" }} Z:{{ data.z || "--" }}
							</div>
							<div class="detail-item" style="width: 12.1%">
								{{ data.materialCode || "--" }}
							</div>
							<div v-if="!compare" v-show="!SelectConut" class="detail-item" style="width: 20.1%">
								<!-- {{  renderTime(data.closeStackTime) || "--" }} -->
								{{ getTime(data.createdTime) || "--" }}
							</div>
							<!-- <div class="detail-item" style="width: 20.1%">
                {{  renderTime(data.closeStackTime) || "--" }}
                {{ getTime(data.closeStackTime) || "--" }}
              </div> -->
							<div class="detail-item" style="width: 25.1%">
								<div class="detail-btn item-audit" @click="todueLook(data.nodeId)">
									查看
								</div>
							</div>
						</div>
						<div class="none-data" v-if="!loading && tableData.length < 1">
							暂无数据
						</div>
					</div>
					<div class="page-wrapper" v-if="!loading && total > 9">
						<div class="page-wrapper-left">
							<div>共{{ total }}条数据，当前第{{ page }}页</div>
							<div style="margin-left: 5px">
								<DropDown :content="rowsShow" :items="rowsData" v-on:sendInfo="rowsInfo"
									class="DropDown"></DropDown>
							</div>
						</div>
						<div class="page-wrapper-right">
							<div class="page-btn" @click="firstPage">首页</div>
							<div class="page-btn" @click="previousPage">上一页</div>
							<div class="page-btn" @click="nextPage">下一页</div>
							<div class="page-btn" @click="lastPage">尾页</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DropDown from "../../../components/DropDownSingle";
	import YuJingTian from "../../../components/YuJingTian";
	import {
		queryHistoryData,
		warehouseNode
	} from "../../../api/basic";
	import {
		getDate,
		renderTime
	} from "../../../tools/methods";
import localforage from 'localforage'
	export default {
		name: "MoistureSensor",
		components: {
			DropDown,
			YuJingTian
		},
		data() {
			return {
				time: [getDate(false), getDate(true)],
				nodeType: "05",
				nodeName: "无线包芯水分传感器",
				tableData: [],
				warehouse: [],
				building: [],
				floor: [],
				area: [],
				stack: [],
				warehouseTitle: "请选择仓库",
				buildingTitle: "请选择楼号",
				floorTitle: "请选择层号",
				areaTitle: "请选择区号",
				stackTitle: "请选择垛位",
				siteId: "",
				siteType: "",
				loading: false,
				all: false,
				page: "1",
				rows: "9",
				total: "",
				rowsShow: "9 条/页",
				rowsData: [{
						name: "9 条/页",
						value: 9
					},
					{
						name: "20 条/页",
						value: 20
					},
					{
						name: "100 条/页",
						value: 100
					},
					{
						name: "200 条/页",
						value: 200
					},
				],
				idList: [],
				excelData: {},
				storehouseFlag: false,
				contrastList: [],
				contrast1: "请选择对比数据",
				contrast2: "请选择对比数据",
				contrastShowBox: 0,
				contrast1show: 0,
				contrast2show: 0,
				// 养护阶段数据
				maintainStageData: [{
						name: "全部",
						value: ""
					},
					{
						name: "自然醇化阶段",
						value: "01"
					},
					{
						name: "防霉杀虫阶段",
						value: "02"
					},
					{
						name: "气调醇化阶段",
						value: "03"
					},
					{
						name: "气调保质阶段",
						value: "04"
					},
				],
				maintainStage: "",
				maintainStageName: "请选择养护阶段",
				CountType: [{
						name: "全部",
						value: ""
					},
					{
						name: "按月",
						value: "2"
					},
					{
						name: "按周",
						value: "1"
					},
					{
						name: "按天",
						value: "0"
					},
				],
				BaoKuoSelect: [{
						name: "不包括",
						value: "0"
					},
					{
						name: "包括",
						value: "1"
					},
				],
				YuJingT: [{
						name: "无",
						value: ""
					},
					{
						name: "小于",
						value: "0"
					},
					{
						name: "大于",
						value: "1"
					},
				],

				// 选择月/周/天
				SelectConut: "",
				// 选择包括还是不包括
				containVal: "0",
				containVal2: "0",
				// 起点
				startTimeData: "",
				// 终点
				endTimeData: "",
				// 氧气浓度上限
				upperVal: "",
				upperHumVal: "",
				// 氧气浓度下限
				lowerVal: "",
				lowerHumVal: "",
				// 数据对比时间点
				DataDBi: 12,
				DBinodeId: "",
				ExcelNodeid: "",
				// 预警值
				val: "",
				// 预警范围
				compare: "",
				val2: "",
				compare2: "",
				excelNum: 0,
			};
		},
		created() {
			let body = {
				warehouseNodeId: "",
				warehouseNodeType: "01",
			};
			warehouseNode(body)
				.then((res) => {
					console.log(res);
					this.warehouse = res.data;
				})
				.catch((err) => {
					console.log(err);
				});
			let _this = this
			localforage.getItem('bodyHistryOMoi').then(res => {
				if (res) {
					this.page = res.page;
					this.rows = res.rows;
					this.nodeType = res.nodeType;
					this.siteId = res.siteId;
					this.siteType = res.siteType;
					switch(res.maintainStage){
						case '01':
							this.maintainStageName="自然醇化阶段"
							break;
						case "02":
							this.maintainStageName="防霉杀虫阶段"
							break;	
						case "03":
							this.maintainStageName="气调醇化阶段"
							break;
						case "04":
							this.maintainStageName="气调保质阶段"
							break;
						case '':
							this.maintainStageName="请选择养护阶段"
							break;			
					}
					this.maintainStage = res.maintainStage;
					// 选择月/周/天
					this.SelectConut = res.dayWeekMonth;
					// 包不包括
					this.containVal = res.containVal;
					// 起点
					this.startTimeData = res.dayStartDate
					this.endTimeData = res.dayEndDate
					// 终点
					this.time = [res.startDate, res.endDate]
					this.storehouseFlag = res.storehouseFlag
					// 氧气浓度上限
					this.upperVal = res.upperVal
					// 氧气浓度下限
					this.lowerVal = res.lowerVal
					// 预警值
					this.val = res.val
					// 预警范围
					this.compare = res.compare
					this.warehouseTitle=res.warehouseTitle
					this.buildingTitle=res.buildingTitle
					this.floorTitle=res.floorTitle
					this.areaTitle=res.areaTitle
					this.stackTitle=res.stackTitle
					// console.log(res)
					_this.handleSearch();
				} else {
					_this.handleSearch();
				}
			})
		},
		methods: {
			// 数据报表
			DataDaoExcelClick: function() {
				if (this.excelNum == 1) {
					console.log(this.DBinodeId)
					let startDate = this.time ? this.time[0] : "";
					let endDate = this.time ? this.time[1] : "";
					location.href = "/api/report/exportBusinessReport?page=" + this.page +
						"&rows=" + this.rows + "&nodeType=" + this.nodeType + "&siteId=" + this.siteId + "&siteType=" +
						this.siteType +
						"&maintainStage=" + this.maintainStage + "&dayWeekMonth=" + this.SelectConut + "&containVal=" +
						this.containVal +
						"&containVal2=" + this.containVal2 + "&dayStartDate=" + this.startTimeData + "&dayEndDate=" +
						this.endTimeData +
						"&startDate=" + startDate + "&endDate=" + endDate + "&storehouseFlag=" + this.storehouseFlag +
						"&upperHumVal=" + this.upperHumVal +
						"&lowerVal=" + this.lowerVal + "&lowerHumVal=" + this.lowerHumVal + "&val=" + this.val +
						"&compare=" + this.compare + "&val2=" + this.val2 + "&compare2=" + this.compare2 + "&nodeId=" +
						this.DBinodeId
				} else {
					if (this.excelNum == 0) {
						this.$message({
							message: "请选一个设备",
							type: "warning",
							center: "true",
							duration: "1000",
						});
					} else {
						this.$message({
							message: "只能选一个设备",
							type: "warning",
							center: "true",
							duration: "1000",
						});
					}

				}

			},
			// 数据对比
			contrastShow: function() {
				if (this.contrastShowBox > 6) {
					this.$message({
						message: "最多选择6条数据",
						type: "warning",
						center: "true",
						duration: "1000",
					});
				} else {
					this.$router.push({
						path: "/historyData/DataDBi",
						query: {
							index: "12",
							nodeType: this.nodeType,
							maintainStage: this.maintainStage,
							startDate: this.time ? this.time[0] : "",
							endDate: this.time ? this.time[1] : "",
							storehouseFlag: this.storehouseFlag,
							// 数据对比时间点
							timeDian: this.DataDBi,
							nodeId: this.DBinodeId,
						},
					});
					this.DBinodeId = "";
				}
			},
			// 查看设备
			todueLook: function(nodeId) {
				this.$router.push({
					path: "/historyData/SheBeiDetail",
					query: {
						index: "12",
						page: this.page,
						rows: this.rows,
						nodeType: this.nodeType,
						siteId: this.siteId,
						siteType: this.siteType,
						maintainStage: this.maintainStage,
						// 选择月/周/天
						dayWeekMonth: this.SelectConut,
						// 包不包括
						containVal: this.containVal,
						// 起点
						dayStartDate: this.startTimeData,
						// 终点
						dayEndDate: this.endTimeData,
						startDate: this.time ? this.time[0] : "",
						endDate: this.time ? this.time[1] : "",
						storehouseFlag: this.storehouseFlag,
						// 氧气浓度上限
						upperVal: this.upperVal,
						// 氧气浓度下限
						lowerVal: this.lowerVal,
						nodeId: nodeId,
						// 预警值
						val: this.val,
						// 预警范围
						compare: this.compare,
					},
				});
			},
			// 時間起点的改变带动终点的改变
			endTimeChange: function() {
				if (this.startTimeData != 23) {
					if (this.startTimeData == "") {
						this.endTimeData = "";
					} else {
						this.endTimeData = parseInt(this.startTimeData) + 1;
					}
				} else {
					this.endTimeData = 0;
				}
			},
			showInfoCountType: function(data) {
				this.SelectConut = data.value;
			},
			BaoKuoSelectType: function(data) {
				this.containVal = data.value;
			},
			YuJingTiType: function(data) {
				if (data.value == "") {
					this.val = "";
					this.compare = data.value;
				} else {
					this.compare = data.value;
				}
			},
			// 选择养护阶段
			showInfoMaintainStag: function(data) {
				this.maintainStage = data.value;
				this.maintainStageName=data.name;
			},
			toOxygenSensor: function() {
				this.$router.push({
					path: "/historyData",
					query: {
						index: "12",
					},
				});
			},
			toTemperatureAndHumiditySensor: function() {
				this.$router.push({
					path: "/historyData/TemperatureAndHumiditySensor",
					query: {
						index: "12",
					},
				});
			},
			toTemperatureSensor: function() {
				this.$router.push({
					path: "/historyData/TemperatureSensor",
					query: {
						index: "12",
					},
				});
			},
			toCarbonDioxideSensor: function() {
				this.$router.push({
					path: "/historyData/CarbonDioxideSensor",
					query: {
						index: "12",
					},
				});
			},
			toTypeStatistics: function() {
				this.$router.push({
					path: "/historyData/TypeStatistics",
					query: {
						index: "12",
					},
				});
			},
			// 格式化时间
			getTime: function(time) {
				return renderTime(time);
			},

			// 选择仓库
			showInfoW: function(data) {
				this.warehouseTitle = data.name;
				this.siteId = data.id;
				this.siteType = data.siteType;
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: "02",
				};
				warehouseNode(body)
					.then((res) => {
						console.log(res);
						this.building = res.data;
						this.buildingTitle = "请选择楼号";
						this.floor = [];
						this.floorTitle = "请选择层号";
						this.area = [];
						this.areaTitle = "请选择区号";
						this.stack = [];
						this.stackTitle = "请选择垛位";
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 选择楼号
			showInfoB: function(data) {
				this.buildingTitle = data.name;
				this.siteId = data.id;
				this.siteType = data.siteType;
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: "03",
				};
				warehouseNode(body)
					.then((res) => {
						console.log(res);
						this.floor = res.data;
						this.floorTitle = "请选择层号";
						this.area = [];
						this.areaTitle = "请选择区号";
						this.stack = [];
						this.stackTitle = "请选择垛位";
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 选择层号
			showInfoF: function(data) {
				this.floorTitle = data.name;
				this.siteId = data.id;
				this.siteType = data.siteType;
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: "04",
				};
				warehouseNode(body)
					.then((res) => {
						console.log(res);
						this.area = res.data;
						this.areaTitle = "请选择区号";
						this.stack = [];
						this.stackTitle = "请选择垛位";
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 选择区号
			showInfoA: function(data) {
				this.areaTitle = data.name;
				this.siteId = data.id;
				this.siteType = data.siteType;
				let body = {
					warehouseNodeId: data.id,
					warehouseNodeType: "05",
				};
				warehouseNode(body)
					.then((res) => {
						console.log(res);
						this.stack = res.data;
						this.stackTitle = "请选择垛位";
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 选择垛位
			showInfoS: function(data) {
				console.log(data);
				this.stackTitle = data.name;
				this.siteId = data.id;
				this.siteType = data.siteType;
			},
			// 查询数据报表
			handleSearch: function() {
				this.contrastShowBox = 0;
				this.excelNum = 0;
				this.DBinodeId = "";
				this.loading = true;
				this.tableData = [];
				this.all = false;
				this.idList = [];
				let body = {
					page: this.page,
					rows: this.rows,
					nodeType: this.nodeType,
					siteId: this.siteId,
					siteType: this.siteType,
					maintainStage: this.maintainStage,
					// 选择月/周/天
					dayWeekMonth: this.SelectConut,
					// 包不包括
					containVal: this.containVal,
					// 起点
					dayStartDate: this.startTimeData,
					// 终点
					dayEndDate: this.endTimeData,
					startDate: this.time ? this.time[0] : "",
					endDate: this.time ? this.time[1] : "",
					storehouseFlag: this.storehouseFlag,
					// 氧气浓度上限
					upperVal: this.upperVal,
					// 氧气浓度下限
					lowerVal: this.lowerVal,
					// 预警值
					val: this.compare ? this.val : "",
					// 预警范围
					compare: this.compare,
					warehouseTitle: this.warehouseTitle,
					buildingTitle: this.buildingTitle,
					floorTitle: this.floorTitle,
					areaTitle: this.areaTitle,
					stackTitle: this.stackTitle,
				};
				console.log(body);
				queryHistoryData(body)
					.then((res) => {
						console.log(res);
						localforage.setItem('bodyHistryOMoi', body)
						res.data.rows &&
							res.data.rows.map((item) => {
								item.sign = 0;
								item.grey = 0;
								if (this.contrastList.length === 2) {
									if (
										this.contrastList[0].nodeId === item.nodeId ||
										this.contrastList[1].nodeId === item.nodeId
									) {
										item.grey = 1;
									}
								} else if (this.contrastList.length === 1) {
									if (this.contrastList[0].nodeId === item.nodeId) {
										item.grey = 1;
									}
								}
							});
						this.tableData = res.data.rows;
						this.total = res.data.total;
						console.log(this.tableData);
						this.loading = false;
					})
					.catch((err) => {
						console.log(err);
						this.loading = false;
					});
			},
			firstPage: function() {
				console.log("首页");
				if (this.page === 1) {
					this.$message({
						message: "当前为第一页",
						type: "warning",
						center: "true",
						duration: "1000",
					});
				} else {
					this.page = 1;
					this.handleSearch();
				}
			},
			previousPage: function() {
				console.log("上一页");
				if (this.page < 2) {
					this.$message({
						message: "当前为第一页",
						type: "warning",
						center: "true",
						duration: "1000",
					});
				} else {
					this.page--;
					this.handleSearch();
				}
			},
			nextPage: function() {
				console.log("下一页");
				if (parseInt(this.total / this.rows) + 1 > this.page) {
					this.page++;
					this.handleSearch();
				} else {
					this.$message({
						message: "当前为最后一页",
						type: "warning",
						center: "true",
						duration: "1000",
					});
				}
			},
			lastPage: function() {
				console.log("尾页");
				if (this.page === parseInt(this.total / this.rows) + 1) {
					this.$message({
						message: "当前为最后一页",
						type: "warning",
						center: "true",
						duration: "1000",
					});
				} else {
					if (Math.round(this.total % this.rows) === 0) {
						this.page = parseInt(this.total / this.rows);
					} else {
						this.page = parseInt(this.total / this.rows) + 1;
					}
					this.handleSearch();
				}
			},
			rowsInfo: function(data) {
				console.log(data);
				this.rows = data.value;
				this.rowsShow = data.name;
				this.page = 1;
				this.handleSearch();
			},
			selectAll: function() {
				this.all = !this.all;
				let idList = [];
				if (this.all) {
					this.tableData.map((data, index) => {
						data.sign = 1;
						idList.push(data);
					});
					this.idList = idList;
				} else {
					this.tableData.map((data, index) => {
						data.sign = 0;
						this.idList = [];
					});
				}
				console.log(this.idList);
			},
			selectSingle: function(body) {
				console.log(this.DBinodeId);
				this.tableData.map((data, index) => {
					if (body === data) {
						data.sign = data.sign === 1 ? 0 : 1;
						if (data.sign === 1) {
							this.excelNum++;
							this.idList.push(data);
							this.contrastShowBox++;
							if (this.DBinodeId == "") {
								this.DBinodeId += body.nodeId;
							} else {
								this.DBinodeId += "," + body.nodeId;
							}
						} else {
							this.excelNum--;
							this.contrastShowBox--;
							if (this.DBinodeId == body.nodeId) {
								this.DBinodeId = "";
							} else {
								this.DBinodeId = this.DBinodeId.replace("," + body.nodeId, "");
								this.DBinodeId = this.DBinodeId.replace(body.nodeId + ",", "");
							}
							let idList = [];
							this.idList.map((item, index) => {
								if (item !== body) {
									idList.push(item);
								}
							});
							this.idList = idList;
						}
						console.log(this.idList);
					}
				});
				this.all = this.idList.length === this.tableData.length;
				console.log(this.idList);
			},
			// 导出表格数据处理
			downloadDatarReport() {
				if (!this.idList[0]) {
					this.$message({
						message: "请选择要导出的数据",
						type: "warning",
					});
				} else {
					console.log(this.tableData);
					const tHeader = [
						"垛位号",
						"烟叶代码",
						"烟叶名称",
						"养护阶段",
						"当前湿度",
						"最大湿度",
						"最小湿度",
						"平均湿度",
						"时间",
					];
					const filterVal = [
						"stack",
						"materialCode",
						"materialName",
						"maintainStage",
						"val",
						"maxVal",
						"minVal",
						"avgVal",
						"createdTime",
					];
					const list = this.idList.map((item) => {
						return {
							stack: item.stack,
							materialCode: item.materialCode,
							materialName: item.materialName,
							maintainStage: item.maintainStage ? item.maintainStage.name : "",
							val: item.val,
							maxVal: item.maxVal,
							minVal: item.minVal,
							avgVal: item.avgVal,
							createdTime: this.getTime(item.createdTime),
						};
					});
					this.excelData = {
						tHeader: tHeader,
						filterVal: filterVal,
						list: list,
						name: this.nodeName,
					};
					console.log(this.excelData);
					this.export2Excel(this.excelData);
				}
			},
			export2Excel: function(body) {
				require.ensure([], () => {
					const {
						exportJson
					} = require("../../../vendor/Export2Excel");
					const tHeader = body.tHeader;
					const filterVal = body.filterVal;
					const list = body.list;
					const data = this.formatJson(filterVal, list);
					exportJson(tHeader, data, body.name + "--数据报表");
				});
				this.$message({
					message: "导出数据成功",
					type: "success",
				});
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map((v) => filterVal.map((j) => v[j]));
			},
		},
	};
</script>

<style scoped>
	@import "historyData.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/historyData/MoistureSensor.vue